<template>
  <div
    @click="$emit('click')"
  >
    <div class="bg-white flex rounded  shadow-md hover:shadow-lg cursor-pointer p-6" :class="cardClass">
      <div class="full-svg p-4" v-if="card.img">
        <component :is="card.img"></component>
      </div>
      <div>
        <zt-icon v-if="card.icon" :name="card.icon" class="text-3xl pr-2"/>
      </div>
      <div class="w-8/12 pl-2 content-center">
          <p class="font-medium text-xl mb-3 text-zt-dark-600 porlet-title">
          {{ card.title }}
        </p>
        <span class="text-zt-dark-300">{{ card.subtitle }}</span>
      </div>
    </div>
  </div>
  
</template>

<script>
import SalaryAdvanceSVG from "../components/SVG/SalaryAdvanceSVG.vue";
import LoanSVG from '../components/SVG/LoanSVG.vue';
export default {
  props: {
    card: {
      type: Object,
      required: true,
    },
    cardClass: {
      type: String,
      default: '',
    },
  },
  components: {
    LoanSVG,
    SalaryAdvanceSVG,
  },
};
</script>

<style scoped>
/* Estilos específicos del componente si son necesarios */
</style>